import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Mobile-first collapsible wrapper.
 * - On screens < md: renders a tap-to-expand accordion with heading + chevron,
 *   collapsed by default (configurable via `defaultOpen`).
 * - On md+ screens: renders children unconditionally — the full section is
 *   always visible on desktop, so this component is a no-op there.
 *
 * The desktop markup lives OUTSIDE the collapsible wrapper so we don't double
 * paint identical content; the owner just wraps the body of their mobile view
 * and provides a desktop fallback via the `desktopChildren` slot (or the
 * default `children` when they're the same).
 */
export default function MobileCollapse({
  heading,
  subheading,
  defaultOpen = false,
  previewLabel,
  children,
  testId,
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="md:hidden" data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-3 py-4 px-5 rounded-2xl bg-white border border-stone-200 shadow-sm active:bg-stone-50 transition-colors"
      >
        <div className="text-left min-w-0">
          <div className="font-bold text-stone-900 truncate" style={{ fontFamily: "Outfit" }}>
            {heading}
          </div>
          {(subheading || previewLabel) && (
            <div className="text-xs text-stone-500 mt-0.5 truncate">
              {subheading || previewLabel}
            </div>
          )}
        </div>
        <ChevronDown
          className={`w-5 h-5 text-stone-500 shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && <div className="mt-4">{children}</div>}
    </div>
  );
}
